import { RESOLUTION_FIELD, SECURITY_FIELD, PRIORITY_FIELD } from './graphql-field-types.tsx';

export const INCOMPATIBLE_FIELDS_LEARN_MORE_LINK =
	'https://support.atlassian.com/jira-core-cloud/docs/create-and-work-with-issues/';

export const NEW_GIC_LEARN_MORE_LINK =
	'https://support.atlassian.com/jira-work-management/docs/what-is-the-new-jira-issue-create-experience/';

export const FIELDS_LEARN_MORE_LINKS = {
	[RESOLUTION_FIELD]: '/secure/ShowConstantsHelp.jspa?decorator=popup#ResolutionTypes',
	[SECURITY_FIELD]: '/secure/ShowConstantsHelp.jspa?decorator=popup#SecurityLevels',
	[PRIORITY_FIELD]: '/secure/ShowConstantsHelp.jspa?decorator=popup#PriorityLevels',
} as const;

export const USER_GIC_POSITIONING_SPOTLIGHT = 'jira.user.gic.positioning.spotlight';

export const ESC_KEY_KEYCODE = 27;
